import { render, staticRenderFns } from "./Hello.vue?vue&type=template&id=40df116e&scoped=true&"
var script = {}
import style0 from "./Hello.vue?vue&type=style&index=0&id=40df116e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40df116e",
  null
  
)

export default component.exports